import { useEffect } from 'react'
import { Toast } from '@/shared/components'
import { ApplicationFormDetailsSection } from './applicationForm/components/ApplicationFormDetailsSection'
import { ApplicationFormHeader } from './applicationForm/components/ApplicationFormHeader'
import { ApplicationEligibilitySection } from './applicationForm/components/ApplicationEligibilitySection'
import { useApplicationFormState } from './applicationForm/hooks/useApplicationFormState'
import { useApplicationFormSubmission } from './applicationForm/hooks/useApplicationFormSubmission'
import { clearUnauthenticatedApplicationStorage } from './applicationForm/utils/storage'

export function ApplicationFormPage() {
  const state = useApplicationFormState()
  const {
    clearFieldError,
    handleAddressChange,
    handleAddressSelect,
    handleEmailChange,
    handlePhoneNumberChange,
    handleTermsAcceptedChange,
    updateField,
    validateAndRegister
  } = useApplicationFormSubmission({
    state
  })

  useEffect(() => {
    clearUnauthenticatedApplicationStorage()
  }, [])

  return (
    <div className="bg-white px-8 py-10 md:px-4">
      {state.submitError && (
        <Toast message={state.submitError} onClose={() => state.setSubmitError(null)} />
      )}
      <div className="mx-auto max-w-4xl">
        <ApplicationFormHeader />
        <div className="mx-auto max-w-3xl pt-6">
          <ApplicationFormDetailsSection
            addressStateRestriction={state.addressStateRestriction}
            fieldErrors={state.fieldErrors}
            fieldEditability={state.fieldEditability}
            formData={state.formData}
            fullAddress={state.fullAddress}
            onAddressChange={handleAddressChange}
            onAddressSelect={handleAddressSelect}
            onClearFieldError={clearFieldError}
            onEmailChange={handleEmailChange}
            onFieldChange={updateField}
            onPhoneNumberChange={handlePhoneNumberChange}
          />
          <div className="border-t border-gray-lighter" />
          <ApplicationEligibilitySection
            isSubmitting={state.isSubmitting}
            isTermsAcceptedDisabled={state.fieldEditability.smsConsent === false}
            onRegister={validateAndRegister}
            onTermsAcceptedChange={handleTermsAcceptedChange}
            termsAccepted={state.formData.termsAccepted}
            termsAcceptedError={state.fieldErrors.termsAccepted}
          />
        </div>
      </div>
    </div>
  )
}
